<div class="topbar-breadcrumb">
    <div class="breadcrumb px-3 py-2">
        @for (bc of breadcrumbService.breadcrumbs(); track $index) {
        @if (bc.iconClass) {
        <i [class]="bc.iconClass + ' me-2 text-muted'" aria-hidden="true"></i>
        }

        @if (bc.route) {
        <a class="breadcrumb-link text-muted" [routerLink]="bc.route">
            @if (bc.translate === false) {
            {{ bc.label }}
            } @else {
            {{ bc.label | translate }}
            }
        </a>
        } @else {
        <span class="breadcrumb-current">
            @if (bc.translate === false) {
            {{ bc.label }}
            } @else {
            {{ bc.label | translate }}
            }
        </span>
        }

        @if ($index < breadcrumbService.breadcrumbs().length - 1) { <span class="mx-2 text-muted">›</span>
            }
            }
    </div>
</div>
